import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/apiHelper'; // Twój pomocnik do zapytań API
import { invalidateApiCache } from '../../utils/apiCache';
import Page from '../molecules/Page'; // Zaimportowałem Page dla spójnego wyglądu

const AppleCallback = () => {
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleAppleLogin = async () => {
            const code = localStorage.getItem('appleAuthCode');
            const id_token = localStorage.getItem('appleIdToken');

            // Wyczyść dane z localStorage od razu po odczytaniu
            localStorage.removeItem('appleAuthCode');
            localStorage.removeItem('appleIdToken');

            if (!id_token) { // Zazwyczaj sam id_token wystarczy, ale zostawiam oba
                setError('Nie znaleziono danych autoryzacyjnych Apple. Spróbuj ponownie.');
                setTimeout(() => navigate('/login'), 3000);
                return;
            }

            try {
                // Wyślij kod i id_token do swojego backendu
                // Upewnij się, że backend /auth/apple/ zwraca teraz flagę is_new
                const response = await api.post('/auth/apple/', {
                    code: code, // Może nie być potrzebny, jeśli backend bazuje tylko na id_token
                    id_token: id_token,
                });

                // ZMIANA: Implementacja nowej logiki 'is_new'
                if (response.status === 200) {
                    // 1. Destrukturujemy nową odpowiedź z backendu
                    const { token, preferences, is_new } = response.data;

                    // 2. Zawsze zapisujemy token i user_id
                    localStorage.setItem('token', token);
                    localStorage.setItem('user_id', preferences.user_id);
                    invalidateApiCache('user_dashboard_data', true);

                    if (is_new) {
                        // 3. NOWA LOGIKA: Przekieruj do uzupełnienia profilu
                        navigate("/complete-profile", { 
                            state: { email: preferences.email } // Przekazujemy email
                        });
                    } else {
                        // 4. STARA LOGIKA: Zaloguj istniejącego użytkownika
                        localStorage.setItem('user_preferences', JSON.stringify(preferences));
                        navigate('/app');
                    }
                }
                // Koniec zmiany
                
            } catch (err) {
                console.error('Błąd logowania przez Apple:', err);
                setError('Logowanie przez Apple nie powiodło się. Spróbuj ponownie.');
                setTimeout(() => navigate('/login'), 3000);
            }
        };

        handleAppleLogin();
    }, [navigate]);

    // Używamy komponentu Page dla spójnego layoutu w trakcie ładowania
    return (
        <Page showNav={false}>
            <div className="flex flex-col items-center justify-center min-h-screen text-center px-4">
                <div className="bg-white p-10 rounded-xl shadow-lg">
                    <h2 className="text-xl font-semibold mb-4">
                        Przetwarzanie logowania Apple...
                    </h2>
                    {error ? (
                        <p className="text-red-600">{error}</p>
                    ) : (
                        <p className="text-gray-600">Proszę czekać...</p>
                        // Możesz tu dodać komponent spinnera
                    )}
                </div>
            </div>
        </Page>
    );
};

export default AppleCallback;
